import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard, sessionSeuleGuard } from './core/guards/auth.guard';
import { modePosGuard, sansMobileGuard, venteSeulementGuard } from './core/guards/mode-pos.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        // Hors du layout et hors de `authGuard` : c'est la page vers laquelle
        // `authGuard` renvoie quand le poste change de main.
        path: 'preparation-poste',
        canActivate: [sessionSeuleGuard],
        loadComponent: () => import('./features/preparation-poste/preparation-poste.component').then(m => m.PreparationPosteComponent)
    },
    {
        // Plan « Aucun » : seul ecran ouvert, hors du layout et de sa navigation.
        // `sansMobileGuard` verifie la session PUIS le mode, en sequence.
        path: 'plan-sans-mobile',
        canActivate: [sansMobileGuard],
        loadComponent: () => import('./features/plan-sans-mobile/plan-sans-mobile.component').then(m => m.PlanSansMobileComponent)
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        // Apres `authGuard` (le routeur attend le garde du parent avant ceux des enfants) :
        // le mode n'est jamais lu sans session.
        canActivateChild: [modePosGuard],
        children: [
            {
                path: 'cash-opening',
                canActivate: [venteSeulementGuard],
                loadComponent: () => import('./features/cash-register/cash-opening.component').then(m => m.CashOpeningComponent)
            },
            {
                path: 'cash-closing',
                redirectTo: 'cash-transfer',
                pathMatch: 'full'
            },
            {
                path: 'cash-transfer',
                canActivate: [venteSeulementGuard],
                loadComponent: () => import('./features/cash-register/cash-transfer.component').then(m => m.CashTransferComponent)
            },
            {
                // Hub Caisse — cible de la nav (MOB-004/MOB-008), toujours
                // accessible (pas conditionne a une session active) : garde
                // Historique + Transfert/Mouvement/Cloture derriere 4
                // onglets. /cash-transfer reste atteignable telle quelle
                // (lien direct existant, compatibilite arriere).
                path: 'cash-register',
                canActivate: [venteSeulementGuard],
                loadComponent: () => import('./features/cash-register/cash-register-hub.component').then(m => m.CashRegisterHubComponent)
            },
            {
                // MOB-013 — écran d'accueil du quart, atterrissage définitif
                // après connexion (remplace l'atterrissage direct sur /sales).
                path: 'home',
                loadComponent: () => import('./features/shift-home/accueil.component').then(m => m.AccueilComponent)
            },
            {
                path: 'sales',
                canActivate: [venteSeulementGuard],
                loadComponent: () => import('./features/sales/sales.component').then(m => m.SalesComponent)
            },
            {
                path: 'messages',
                loadComponent: () => import('./features/messaging/messaging.component').then(m => m.MessagingComponent)
            },
            {
                path: 'calls',
                loadComponent: () => import('./features/calls/call-log/call-log.component').then(m => m.CallLogComponent)
            },
            {
                // Route litterale AVANT la route parametree : 'compose' ne
                // doit jamais etre capture par ':id' (Règle 12 — ordre des
                // routes).
                path: 'email/compose',
                loadComponent: () => import('./features/email/email-compose/email-compose.component').then(m => m.EmailComposeComponent)
            },
            {
                path: 'email/:id',
                loadComponent: () => import('./features/email/email-read/email-read.component').then(m => m.EmailReadComponent)
            },
            {
                path: 'email',
                loadComponent: () => import('./features/email/email-inbox/email-inbox.component').then(m => m.EmailInboxComponent)
            },
            {
                path: 'hr',
                loadComponent: () => import('./features/hr/hr.component').then(m => m.HrComponent)
            },
            {
                path: 'history',
                canActivate: [venteSeulementGuard],
                loadComponent: () => import('./features/history/history.component').then(m => m.HistoryComponent)
            },
            {
                path: 'calendar',
                loadComponent: () => import('./features/calendar/calendar.component').then(m => m.CalendarComponent)
            },
            {
                path: 'settings',
                loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent)
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            }
        ]
    }
];
